<template>
    <div>
        <div class="">
            <table class="board_table">
                <colgroup>
                    <col width="15%" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                    <col width="auto" />
                </colgroup>
                <thead>
                    <tr>
                        <th rowspan="4">구분</th>
                    </tr>
                    <tr>
                        <th colspan="6">업소 유형분류</th>

                        <th rowspan="3">
                            계
                            <br />
                            (A + B)
                        </th>
                        <th colspan="2">합</th>
                    </tr>
                    <tr>
                        <th rowspan="2">출장형</th>
                        <th rowspan="2">조건만남형</th>
                        <th colspan="2">업소형</th>
                        <th rowspan="2">기타</th>
                        <th rowspan="2">해당없음</th>
                        <th rowspan="2">미삭제(A)</th>
                        <th rowspan="2">삭제요청(B)</th>
                    </tr>
                    <tr>
                        <th>주점형</th>
                        <th>위장형</th>
                    </tr>
                </thead>
                <tbody v-if="!props.loading">
                    <tr v-for="(item, idx) in props.list" :key="idx">
                        <td v-if="item.sns === 1">
                            X
                            <br />
                            (구 트위터)
                        </td>
                        <td v-else-if="item.sns === 2">구글</td>
                        <td v-else-if="item.sns === 3">네이버</td>
                        <td v-else-if="item.sns === 4">유튜브</td>
                        <td v-else-if="item.sns === 5">인스타</td>
                        <td v-else-if="item.sns === 6">블루스카이</td>
                        <td>{{ item.cntType1 ? numberFormat(item.cntType1) : 0 }}</td>
                        <td>{{ item.cntType4 ? numberFormat(item.cntType4) : 0 }}</td>
                        <td>{{ item.cntType2 ? numberFormat(item.cntType2) : 0 }}</td>
                        <td>{{ item.cntType3 ? numberFormat(item.cntType3) : 0 }}</td>
                        <td>{{ item.cntType6 ? numberFormat(item.cntType6) : 0 }}</td>
                        <td>{{ item.cntType9 ? numberFormat(item.cntType9) : 0 }}</td>

                        <td>{{ item.cntType5 ? numberFormat(item.cntType5) : 0 }}</td>

                        <td>{{ item.cntMonitoring ? numberFormat(item.cntMonitoring) : 0 }}</td>
                        <td>{{ item.cntDel ? numberFormat(item.cntDel) : 0 }}</td>
                    </tr>

                    <tr>
                        <td>총 계 (건)</td>
                        <td>{{ numberFormat(totalRow.cntType1) }}</td>
                        <td>{{ numberFormat(totalRow.cntType4) }}</td>
                        <td>{{ numberFormat(totalRow.cntType2) }}</td>
                        <td>{{ numberFormat(totalRow.cntType3) }}</td>
                        <td>{{ numberFormat(totalRow.cntType6) }}</td>
                        <td>{{ numberFormat(totalRow.cntType9) }}</td>
                        <td>{{ numberFormat(totalRow.cntType5) }}</td>
                        <td>{{ numberFormat(totalRow.cntMonitoring) }}</td>
                        <td>{{ numberFormat(totalRow.cntDel) }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="10">
                            <Spinner />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="board_graph_list">
        <Chart style="min-height: 400px" v-for="data in state.chartData" :defaultLayout="chartLayout" :data="data"></Chart>
    </div>
</template>

<script lang="ts" config>
    import {
        Chart,
        numberFormat,
        computed,
        reactive,
        LayoutOption,
        watch,
        Spinner,
        onMounted,
        ChartSort,
        ChartData,
        setChartData,
    } from "@/BaseComponent";
    export default {
        props: ["list", "chartData", "loading"],
        components: {
            Chart,
            Spinner,
        },
        setup(props: any) {
            const state = reactive({
                isLoading: true,
                chartData: [] as ChartData[],
            });

            const totalRow = computed(() => {
                return {
                    // 1: 출장형, 2: 주점형, 3: 위장형, 4: 조건만남, 5: {cntMonitoring + cntDel}, 6: 기타, 9: 해당없음
                    cntMonitoring: props.list.reduce((sum: any, item: any) => sum + item.cntMonitoring, 0),
                    cntDel: props.list.reduce((sum: any, item: any) => sum + item.cntDel, 0),
                    cntType1: props.list.reduce((sum: any, item: any) => sum + item.cntType1, 0),
                    cntType2: props.list.reduce((sum: any, item: any) => sum + item.cntType2, 0),
                    cntType3: props.list.reduce((sum: any, item: any) => sum + item.cntType3, 0),
                    cntType4: props.list.reduce((sum: any, item: any) => sum + item.cntType4, 0),
                    cntType6: props.list.reduce((sum: any, item: any) => sum + item.cntType6, 0),
                    cntType9: props.list.reduce((sum: any, item: any) => sum + item.cntType9, 0),
                    cntType5: props.list.reduce((sum: any, item: any) => sum + item.cntType5, 0),
                };
            });

            const chartLayout = reactive({
                type: "line",
                xAxisKey: "month",

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부
            } as LayoutOption);

            const snsList = [
                { idx: 1, name: "X (구 트위터)" },
                { idx: 6, name: "블루스카이" },
                { idx: 2, name: "구글" },
                { idx: 3, name: "네이버" },
                { idx: 4, name: "유튜브" },
                { idx: 5, name: "인스타" },
            ];

            const platformChartSort: ChartSort[] = [
                { name: "출장형", valueKey: "cntBussiness" },
                { name: "조건만남형", valueKey: "cntCondition" },
                { name: "주점형", valueKey: "cntTavern" },
                { name: "위장형", valueKey: "cntCamouflage" },
                { name: "기타", valueKey: "cntEtc" },
                { name: "해당없음", valueKey: "cntNone" },
                { name: "미삭제", valueKey: "cntMonitoring", symbol: "emptyRect" },
                { name: "삭제요청", valueKey: "cntDel", symbol: "emptyRect" },
            ];

            onMounted(() => {
                if (props.list.length > 0) state.isLoading = false;
                else state.isLoading = true;

                state.chartData = [];
                if (props.chartData.length > 0) {
                    for (const data of props.chartData) {
                        if (data.length > 0) {
                            const snsName = snsList.find((item) => item.idx === data[0].sns)?.name ?? "기타";
                            state.chartData.push(setChartData(platformChartSort, data, chartLayout.xAxisKey, snsName));
                        }
                    }
                }
            });
            watch(
                () => props.list,
                () => {
                    if (props.list.length > 0) state.isLoading = false;
                    else state.isLoading = true;
                },
            );

            watch(
                () => props.chartData,
                (newValue) => {
                    state.chartData = [];
                    if (newValue.length > 0) {
                        for (const data of newValue) {
                            if (data.length > 0) {
                                const snsName = snsList.find((item) => item.idx === data[0].sns)?.name ?? "기타";
                                state.chartData.push(setChartData(platformChartSort, data, chartLayout.xAxisKey, snsName));
                            }
                        }
                    }
                },
                { deep: true },
            );

            return {
                props,
                state,
                totalRow,
                chartLayout,
                numberFormat,
            };
        },
    };
</script>

<style scoped>
    .dp__input {
        width: 15%;
    }
    .board_graph_top {
        display: flex;
        gap: 20px;
    }
    .board_btn.board_ico_btn.active {
        background-color: var(--lightBlue) !important;
        color: #ffffff !important;
    }
    #board_layer .sch_box {
        height: 45px;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;

        border: 1px solid #dfdfdf;
        height: auto;
    }
    .board_graph_list {
        padding-top: 20px;
    }
</style>
